class MenuGeoliance {

  constructor() {

    this.debug = window.location.search == "?debug" ? true : false;
    // this.debug = true;

    if(this.debug) console.log('MenuGeoliance constructor');
    window.MenuGeoliance = this;
    this.headerTransitionRunning = false;
    this.headerTransitionDuration = 400;

  }

  init() {

    let _self = this;

    if(_self.debug) console.log('MenuGeoliance init vavavooom!', $('body'));

    // window.addEventListener("scroll", );

    
    this.menu = $('#menu-navigation');
    this.menuToggle = $('#menu-open');
    this.header = $('.o-header');
    
    // this.headerTransitionDuration = parseFloat(this.header.css('transition-duration'))*1000;
    this.headerTransitionDuration = 400;
    if (_self.debug) console.log('[Menu] headerTransitionDuration = '+this.headerTransitionDuration);

    // Menu Galaxy
    this.menuGalaxy = $('.o-menu-galaxy');
    $('.o-menu-galaxy__toggle').on('click', e => {
      _self.menuGalaxy.toggleClass('is-open');
      $('body').toggleClass('has-menu-galaxy-open');
    });

    this.initHeaderScrollTrigger();

    $(window).on('scroll', _.throttle(this._scroll.bind(this), 150));
    this._scroll();

    $(window).on('resize', _.debounce(this._resize.bind(this), 400));
    this._resize();

  }

  initHeaderScrollTrigger(){

    let _self = this;

    this.headerScrollTrigger = ScrollTrigger.create({
      id: 'headerScrollTrigger',
      // trigger: $('.o-header').get(0),
      trigger: $('html').get(0),
      // start: "top bottom",
      // end: "bottom-="+$('.o-header').height()+"px top",
      // endTrigger: $('.o-header').get(0),
      start: "top top",
      // end: "top-="+this.header.height()+"px top",
      end: "top-=85px top",
      endTrigger: $('#page').get(0),
      onToggle: self => {
        if(_self.debug) console.log("toggled, headerScrollTrigger isActive:", self, self.isActive);
        //is it in view ?
        if (self.isActive || self.progress == 0) {
          $('body').removeClass('has-scrolled-header');
          _self.headerTransitionRunning = false;
          _self.header.removeClass('is-hidden');
          _self.menuGalaxy.removeClass('is-hidden');
          _self.headerTransitionRunning = true;
          setTimeout(function(){
            _self.headerTransitionRunning = false;
            if(_self.debug) console.log('headerScrollTrigger Menu header transition timeout', _self.headerTransitionRunning);
          }, _self.headerTransitionDuration*1.5);
        } else {
          $('body').addClass('has-scrolled-header');
          _self.menuGalaxy.addClass('is-hidden');
        }
      },
      markers: _self.debug
    });

  }

  closeMenus() {

    if(this.debug) console.log('MenuGeoliance closeMenus');
    
    this.closeMenu();
    this.closeMenuGalaxy();

  }

  openMenu() {

    this.menuToggle.attr('aria-expanded', true);
    this.header.addClass('is-open');
    $('body').addClass('has-menu-open');
    this.menuGalaxy.addClass('is-hidden');

  }

  closeMenu() {

    let _self = this;

    this.menuToggle.attr('aria-expanded', false);
    this.header.removeClass('is-open');
    $('body').removeClass('has-menu-open');
    this.menuGalaxy.removeClass('is-hidden');
    setTimeout(function(){
      // close sub and subsub menus
      _self.closeSubMenus();
    }, 400);

  }

  closeMenuGalaxy() {

    this.menuGalaxy.removeClass('is-open');
    $('body').removeClass('has-menu-galaxy-open');

  }

  closeSubMenus() {

    this.menu.find('.menu-item-has-children.is-active').find('.sub-menu').css('max-height', 0);
    this.menu.find('.menu-item-has-children.is-active').removeClass('is-active');
    this.menu.removeClass('has-active-submenu');
    this.menu.closest('nav').removeClass('has-active-submenu');
    this.header.removeClass('has-active-submenu');

  }

  _resize() {

    let _self = this;

    if(_self.debug) console.log('MenuGeoliance _resize', $(window).width(), window.innerWidth);

      // toggle mobile menu
      this.menuToggle.filter(':not(.has-events-click)').on('click touchend', function(e) {

        e.preventDefault();
        e.stopPropagation();

        if($(this).attr('aria-expanded') == "true") {

          // close menu
          _self.closeMenu();

        } else {

          // open menu
          _self.openMenu();

        }

        // unfocus menu button
        $(this).blur();

    }).addClass('has-events-click');

    if(window.innerWidth < 1280) { // if mobile
      // if(_self.debug) console.log('MenuGeoliance it is mobile', this.menu);

      // 2nd level toggle submenu
      this.menu.find('> .menu-item-has-children > a:not(.has-events-click)').on('click touchend', function(e) {

        e.preventDefault();
        e.stopPropagation();

        if($(this).parent().hasClass('is-active')) {

          //close submenu
          let activeParent = $(this).parent();
          // setTimeout(function(){
            if(_self.debug) console.log('close submenu', activeParent.text());
            activeParent.removeClass('is-active');
            activeParent.find('.sub-menu').css('max-height', 0);
          // },400)
          _self.menu.removeClass('has-active-submenu');
          _self.menu.closest('nav').removeClass('has-active-submenu');
          _self.header.removeClass('has-active-submenu');

        } else {

          //open submenu
          // if(_self.debug) console.log('open submenu?', $(this).parent().text());
          _self.menu.find('.menu-item-has-children').removeClass('is-active').find('.sub-menu').css('max-height', 0);
          $(this).parent().addClass('is-active').find('.sub-menu').css('max-height', $(this).parent().find('.sub-menu').get(0).scrollHeight+18+24);
          _self.menu.addClass('has-active-submenu');
          _self.menu.closest('nav').addClass('has-active-submenu');
          _self.header.addClass('has-active-submenu');

        }

      }).addClass('has-events-click');

      // update has-scrolled-header
      if((typeof this.headerScrollTrigger.isActive != 'undefined' && !this.headerScrollTrigger.isActive) || window.scrollY > this.headerScrollTrigger.end) {
        if(_self.debug) console.log('Menu _resize has scrolled header');
        $('body').addClass('has-scrolled-header');
      } else {
        $('body').removeClass('has-scrolled-header');
      } 

    } else { // if desktop
      if(_self.debug) console.log('MenuGeoliance it is desktop');

      // remove click events for 2nd level
      let linksLevel2 = this.menu.find('> .menu-item-has-children > a.has-events-click');
      if(linksLevel2.length) linksLevel2.off('click touchend').removeClass('has-events-click');

      // close menu, sub and subsub menus
      this.closeMenu();

    }

  }

  _scroll(event) {

    let fromTop = window.scrollY + 0;
    let theBody = $('body');
    let _self = this;

    if(fromTop >= 10) {

      theBody.addClass('is-scrolled');
      this.header.addClass('is-sticky');

      // this.header.on("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", function(){
      //   console.log('header llijhl');
      //   _self.headerTransitionRunning = false;
      // });

      if(!_self.headerTransitionRunning) {

        if( this.lastScrollTop > fromTop) {
          this.header.removeClass('is-hidden');
          // if(!theBody.hasClass('has-scrolled-header') || fromTop < window.innerHeight) this.menuGalaxy.removeClass('is-hidden');
          if(this.headerScrollTrigger.isActive) this.menuGalaxy.removeClass('is-hidden');
          _self.headerTransitionRunning = true;
          setTimeout(function(){
            _self.headerTransitionRunning = false;
            if(_self.debug) console.log('Menu header transition timeout', _self.headerTransitionRunning, _self.headerScrollTrigger.isActive);
          }, this.headerTransitionDuration*1.5);
        } else {
          if(!_self.headerScrollTrigger.isActive) {

            this.header.addClass('is-hidden');
            this.menuGalaxy.addClass('is-hidden');
            if($('.o-landing').hasClass('.o-landing--advanced') && !this.headerScrollTrigger.isActive) {
              theBody.removeClass('has-scrolled-header');
            } else if(!this.headerScrollTrigger.isActive) theBody.addClass('has-scrolled-header');
            _self.headerTransitionRunning = true;
            setTimeout(function(){
              _self.headerTransitionRunning = false;
              if(_self.debug) console.log('Menu header transition timeout', _self.headerTransitionRunning, _self.headerScrollTrigger.isActive);
            }, this.headerTransitionDuration*1.5);

          } else {
            if(!this.headerScrollTrigger.isActive) {
              this.menuGalaxy.addClass('is-hidden');
            }
          }
        }

      } else {

        if((typeof this.headerScrollTrigger.isActive != 'undefined' && !this.headerScrollTrigger.isActive) || window.scrollY > this.headerScrollTrigger.end) {
          if(_self.debug) console.log('Menu _resize has scrolled header');
          theBody.addClass('has-scrolled-header');
        } else {
          theBody.removeClass('has-scrolled-header');
        } 

      }

    } else {
      theBody.removeClass('is-scrolled');
      this.header.removeClass('is-sticky');
      _self.headerTransitionRunning = false;
    }

    this.lastScrollTop = fromTop;

  }


}

export { MenuGeoliance };
